<div class="h-100">

    <div class="row justify-content-end pl-4 pr-4">
        <a class="btn-edit-icon" (click)="startEditingComments()" *ngIf="!isEditing">
            <img src="assets/ph-bhp-layout/svg/icon-edit.svg">
        </a>
    </div>

    <ng-container *ngIf="!isEditing">
        <div class="px-3 observationList" *ngFor="let observation of observations">
            <div>
                <label class="observationTime mb-3">{{observation.observeObservationID}} |
                    {{layoutService.convertUTCStingToLocalDate(observation.createdDateTime) | date:'hh:mm a' }}</label>
                <div class="observationTitle" *ngIf="observation.beforeTouchingPatient">{{
                    translationKeys.Observation.BeforeTouching | translate }}</div>
                <div class="observationTitle" *ngIf="observation.beforeAsepticProcdures">{{
                    translationKeys.Observation.BeforeAseptic | translate }}</div>
                <div class="observationTitle" *ngIf="observation.afterBodyFluidExposure">{{
                    translationKeys.Observation.AfterBodyFluidExposure | translate }}</div>
                <div class="observationTitle" *ngIf="observation.afterTouchingPatient">{{
                    translationKeys.Observation.AfterTouchingAPatient | translate }}</div>
                <div class="observationTitle" *ngIf="observation.afterTouchingPatientSurroundings">{{
                    translationKeys.Observation.AfterTouchingPatientSurroundings | translate }}</div>
                <div class="observationTitle" *ngIf="observation.beforeAsepticProcdures">
                    <label class="observationComment"
                        *ngIf="asepticproceduresValue(observation)">{{asepticproceduresValue(observation) | translate |
                        labelSanitizer}}</label>
                </div>
                <label class="observationComment">{{ getObserveComments(observation) | labelSanitizer}}</label>
            </div>
            <div class="observeActions">
                <div *ngIf="!observation.completed" class="mb-2 d-flex justify-content-center align-items-center warning-icon">
                    <img class="" src="assets/icons/icon-warning-outline.svg" />
                </div>
                <span *ngIf="observation.missed" class="rub-text">{{translationKeys.Observation.Missed |
                    translate}}</span>
                <span *ngIf="observation.handRub" class="rub-text">{{translationKeys.Observation.Handrub |
                    translate}}</span>
                <span *ngIf="observation.handWash" class="rub-text">{{translationKeys.Observation.Handwash |
                    translate}}</span>
                <span *ngIf="observation.gloves" class="rub-text">{{translationKeys.Observation.Gloves |
                    translate}}</span>
                <span *ngIf="observation.unavailable" class="rub-text">{{'OBSERVATION.UNAVAILABLE_LONG' |
                    translate}}</span>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="isEditing">
        <div class="px-3 observationList edit align-items-stretch" *ngFor="let observation of observations">
            <div class="observation-data">
                <label class="observationTime mb-3">{{observation.observeObservationID}} |
                    {{layoutService.convertUTCStingToLocalDate(observation.createdDateTime) | date:'hh:mm a' }}</label>
                <div class="observationTitle" *ngIf="observation.beforeTouchingPatient">{{
                    translationKeys.Observation.BeforeTouching | translate }}</div>
                <div class="observationTitle" *ngIf="observation.beforeAsepticProcdures">{{
                    translationKeys.Observation.BeforeAseptic | translate }}</div>
                <div class="observationTitle" *ngIf="observation.afterBodyFluidExposure">{{
                    translationKeys.Observation.AfterBodyFluidExposure | translate }}</div>
                <div class="observationTitle" *ngIf="observation.afterTouchingPatient">{{
                    translationKeys.Observation.AfterTouchingAPatient | translate }}</div>
                <div class="observationTitle" *ngIf="observation.afterTouchingPatientSurroundings">{{
                    translationKeys.Observation.AfterTouchingPatientSurroundings | translate }}</div>
                <div class="observationTitle" *ngIf="observation.beforeAsepticProcdures">
                    <label class="observationComment"
                        *ngIf="asepticproceduresValue(observation)">{{asepticproceduresValue(observation) | translate |
                        labelSanitizer}}</label>
                </div>
                <div class="pt-4 pb-4 edit-comments-section">
                    <div class="quick-cmt-container">
                        <div class="quick-cmt mr-2" *ngFor="let predefinedComment of predefinedComments">
                            <li [ngClass]="isCommentSelected(predefinedComment, observation) ? 'active' : ''" (click)="selectComment(predefinedComment, observation)">{{ predefinedComment.commentName }} <i class="closeTagIcon"></i></li>
                        </div>
                    </div>

                    <div class="quick-cmt-container pt-4">
                        <div class="comments-container">
                          <label>{{'CONFIGURE.WRITE_COMMENTS_HERE' | translate}}</label>
                          <input inputSanitizer class="text-comt bgWhite form-control" [(ngModel)]="observation.individualComments" type="text" maxlength="500" />
                        </div>
                      </div>
                </div>
            </div>
            <div class="observeActions pt-4">
                <div *ngIf="!observation.completed" class="mb-2 d-flex justify-content-center align-items-center warning-icon">
                    <img class="" src="assets/icons/icon-warning-outline.svg" />
                </div>
                <span *ngIf="observation.missed" class="rub-text">{{translationKeys.Observation.Missed |
                    translate}}</span>
                <span *ngIf="observation.handRub" class="rub-text">{{translationKeys.Observation.Handrub |
                    translate}}</span>
                <span *ngIf="observation.handWash" class="rub-text">{{translationKeys.Observation.Handwash |
                    translate}}</span>
                <span *ngIf="observation.gloves" class="rub-text">{{translationKeys.Observation.Gloves |
                    translate}}</span>
                <span *ngIf="observation.unavailable" class="rub-text">{{'OBSERVATION.UNAVAILABLE_LONG' |
                    translate}}</span>
            </div>
        </div>
        <div class="footer-controls col-sm-12 d-flex justify-content-end">
            <button class="btn-cancel-bordered-bd separate-buttons" (click)="cancelEditingComments()">{{
                translationKeys.Authorization.Cancel | translate }}</button>
            <button class="btn btn-continue-bordered-bd" (click)="saveEditingComments()">{{
                translationKeys.Authorization.Save | translate }}</button>
        </div>
    </ng-container>
</div>